export { AUTHENTICATION_MODAL_COMPONENT } from './cb2-preview-bloc-types';

import { AUTHENTICATION_MODAL_COMPONENT } from './cb2-preview-bloc-types';
import type { Cb2PreviewScenarioPayload } from './cb2-preview-protocol';
import { previewScenarioData } from './preview-scenario-data.util';
import type { AuthenticationModalScenarioContent } from '@front-platform/content-builder';

export function resolveAuthenticationModalPreviewContent(
  payload: Cb2PreviewScenarioPayload | null | undefined,
): AuthenticationModalScenarioContent | null {
  return previewScenarioData<AuthenticationModalScenarioContent>(
    payload,
    AUTHENTICATION_MODAL_COMPONENT,
  );
}
